/**
 * FieldText - Text input field with tooltip for ticket creation
 * Adapted from Thaklis app
 */
import React from 'react';
import { TextField, Tooltip, Box } from '@mui/material';

const FieldText = ({ onChange, field, index, contextProps }) => {
  const { shouldShowFieldInSection } = contextProps || {};
  const fieldLabel = field.label || field.title || field.name || `Field ${index + 1}`;

  const isVisible = shouldShowFieldInSection ? shouldShowFieldInSection(field.name, field.category) : true;

  if (!isVisible) return null;

  const tooltipContent = (
    <Box sx={{ p: 1, maxWidth: 300 }}>
      <div><strong>Field:</strong> {field.name || 'N/A'}</div>
      <div><strong>Type:</strong> {field.type || 'TEXT'}</div>
      <div><strong>Category:</strong> {field.category || 'N/A'}</div>
    </Box>
  );

  return (
    <Tooltip title={tooltipContent} arrow placement="top">
      <TextField
        required={field.mandatory || field.required}
        name={field.name || 'description'}
        label={fieldLabel}
        fullWidth
        value={field.value || ''}
        onChange={(e) => onChange(e.target.value, field, index)}
      />
    </Tooltip>
  );
};

export default FieldText;
